import React, { useEffect } from 'react';
import { Close } from '@mui/icons-material';

import PlayerPromos from 'components/PlayerPromos/PlayerPromos';

import styles from './PromoDialog.module.scss';

interface PromoDialogProps {
  open: boolean;
  onClose: () => void;
}

const PromoDialog: React.FC<PromoDialogProps> = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className={styles.root} role='dialog' aria-modal='true'>
      <div className={styles.backdrop} onClick={onClose} aria-hidden />
      <div className={styles.sheet}>
        <div className={styles.header}>
          <h2 className={styles.title}>Promotions</h2>
          <button
            type='button'
            className={styles.closeButton}
            onClick={onClose}
            aria-label='Close promotions'>
            <Close fontSize='small' />
          </button>
        </div>
        <div className={styles.body}>
          <PlayerPromos />
        </div>
      </div>
    </div>
  );
};

export default PromoDialog;
